import type { TicketStatus } from "api/types/tickets.types";

// 수강권 상태 코드 → Badge variant 매핑
export const TICKET_STATUS_BADGE: Record<TicketStatus, "active" | "pending" | "rejected" | "draft" | "info"> = {
  UNUSED: "info",
  PARTIALLY_USED: "pending",
  FULLY_USED: "active",
  EXPIRED: "draft",
  CANCELLED: "rejected",
};

// 수강권 상태 코드 → 한글 라벨
export const TICKET_STATUS_LABEL: Record<TicketStatus, string> = {
  UNUSED: "미사용",
  PARTIALLY_USED: "부분 사용",
  FULLY_USED: "모두 사용",
  EXPIRED: "만료",
  CANCELLED: "취소",
};

// Select 필터/수정용 옵션 (status choices와 일치)
export const TICKET_STATUS_OPTIONS: { value: TicketStatus; label: string }[] = [
  { value: "UNUSED", label: "미사용" },
  { value: "PARTIALLY_USED", label: "부분 사용" },
  { value: "FULLY_USED", label: "모두 사용" },
  { value: "EXPIRED", label: "만료" },
  { value: "CANCELLED", label: "취소" },
];
